<template>
  <div class="wrap">
    <div class="page-list" v-show="isList">
      <div class="border-bottom">
        <div class="title">开票申请</div>
      </div>
      <div class="filter">
        <div class="fast-group">
          <button class="ap-btn-red ap-btn-red-hover1" @click="$router.push('/buyer/apply/create')">新建开票申请</button>
          <div class="tit" style="color:#666;">快速搜索</div>
          <div class="fast-item" :class="type=='all'?'active':''" @click="type='all'">所有</div>
          <div class="fast-item" :class="type=='draft'?'active':''" @click="type='draft'">草拟中</div>
          <div
            class="fast-item"
            :class="type=='unInvoice'?'active':''"
            @click="type='unInvoice'"
          >待开票</div>
          <div class="fast-item" :class="type=='invoice'?'active':''" @click="type='invoice'">已开票</div>
        </div>
        <SearchField
          style="float:right;width:200px;"
          :small="true"
          :value.sync="searchText"
          @submit="search"
          placeholder="订单号"
        ></SearchField>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>发票抬头</th>
            <th>申请开票金额 (元)</th>
            <th>关联物流单</th>
            <th>开票内容</th>
            <th>状态</th>
            <th>提交申请日期</th>
            <th>申请人</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in results" :key="item.id">
            <td>{{ item.title }}</td>
            <td>{{ item.amount | toMoney }}</td>
            <td>{{ item.numberOfLogistic }}</td>
            <td>{{ item.requireContentLiteral }}</td>
            <td>
              <span v-if="item.processStatus=='DRAFT'">草拟中</span>
              <span v-if="item.processStatus=='PENDING'">待开票</span>
              <span v-if="item.processStatus=='INVOICED'">已开票</span>
            </td>
            <td>{{ item.submittedTime | toShortDate }}</td>
            <td>{{ item.creatorName }}</td>
            <td>
              <button
                class="btn btn-secondary btn-sm"
                v-if="item.processStatus=='DRAFT'"
                @click="$router.push('/buyer/apply/create?id=' + item.id)"
              >编辑</button>
              <button
                class="btn btn-secondary btn-sm"
                v-else
                @click="$router.push('/buyer/apply/' + item.id)"
              >查看</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="margin-top:30px">
        <Pagination :total="total" @page-to="getData" />
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Pagination from "@components/Pagination.vue";
import SearchField from "@components/SearchField.vue";

export default {
  components: {
    Pagination,
    SearchField
  },
  data() {
    return {
      type: "all",
      total: 0,
      results: [],
      searchText: ""
    };
  },
  computed: {
    isList() {
      return this.$route.path == "/buyer/apply";
    }
  },
  created() {
    if (this.isList) {
      this.getData();
    }
  },
  watch: {
    $route(_new) {
      if (_new.path == "/buyer/apply") {
        this.getData();
      }
    }
  },
  methods: {
    getData(args) {
      args = args || {
        limit: this.$limit,
        offset: 0
      };
      let params = {
        criteria: {
          // keyword: this.searchText
        },
        limit: args.limit,
        offset: args.offset
      };
      this.$list("/pass/salesInvoice/query", params, {
        success(res) {
          this.total = res.total;
          this.results = res.results;
        }
      });
    },
    search() {}
  }
};
</script>

<style lang="less" scoped>
@import url("~@assets/less/vars.less");

.wrap {
  padding: 20px;
  background: #fff;
  .page-list {
    .title {
      margin-bottom: 20px;
      font-size: 24px;
      line-height: 36px;
    }
    .filter {
      padding: 20px 0;
      .ap-btn-red {
        margin-right: 200px;
      }
    }
    .table td {
      vertical-align: middle;
    }
  }
}
</style>